import React from 'react'
import SecuredBadge from 'library/molecules/SecuredBage'
import { Text } from 'library/atoms/Typography'
import {
  StyleGuideMain,
  StyleGuideIdProps
} from 'shared/library/pages/StyleGuide'

const PROPS = {
  Description: () => (
    <Text>Use this component to show secure Icon and text to the user</Text>
  ),
  examples: [
    {
      title: 'SecuredBadge',
      code: `<SecuredBadge />`,
      scope: { SecuredBadge }
    }
  ]
}

const SecuredBadgeStyleGuide = (props: StyleGuideIdProps) => (
  <StyleGuideMain {...props} {...PROPS} />
)

export default SecuredBadgeStyleGuide
